<h1 mat-dialog-title>{{ headline }}</h1>
<ng-container *ngIf="formGroup">
    <app-textarea Key="Name" [Required]="true" [Value]="formGroup.controls.Name"></app-textarea>
    <mat-form-field class="full-width">
        <mat-label>Fahrtzonennummer</mat-label>
        <input matInput required type="number" placeholder="Fahrtzonennummer" [formControl]="formGroup.controls.TravelZoneNumber"/>
    </mat-form-field>
    <app-textarea Key="Bearbeitungsschlüssel" [Value]="formGroup.controls.Bearbeitungsschluessel"></app-textarea>
    <mat-form-field class="full-width">
        <mat-label>Wert</mat-label>
        <input matInput type="number" placeholder="Wert" [formControl]="formGroup.controls.Amount"/>
    </mat-form-field>
    <mat-form-field class="full-width">
        <mat-label>Prozentualer Wert</mat-label>
        <input matInput type="number" placeholder="Prozentualer Wert" [formControl]="formGroup.controls.PercentAmountFromTravelZone"/>
    </mat-form-field>
    <app-textarea [MinRows]="4" Key="Kommentar" [Value]="formGroup.controls.Description"></app-textarea>
    <div class="flex items-center gap-4">
        Buchungsposition:
        <mat-chip *ngIf="selectedArlTemplate$ | async as template"
            >{{ template.BookingText }} - {{ template.Information }} ({{ template.BaseCost | currency }})
            <button matChipRemove (click)="formGroup.controls.arlTemplate.setValue(null);formGroup.controls.arlTemplate.markAsDirty()">
                <fa-icon icon="circle-xmark"></fa-icon>
            </button>
        </mat-chip>
        <button app-round-button matTooltip="Bearbeiten" matTooltipPosition="left" (click)="onSelectArlClick()">
            <fa-icon [icon]="formGroup.value.arlTemplate ? 'pencil-alt' : 'plus'"></fa-icon>
        </button>
    </div>
    <mat-dialog-actions class="flex justify-between gap-4">
        <button app-button Color="cancel" Inverted mat-dialog-close>abbrechen</button>
        <button app-button Color="green" (click)="submit()" [IsLoading]="ls.IsLoading$ | async" [Disabled]="formGroup.invalid || formGroup.pristine">speichern</button>
    </mat-dialog-actions>
</ng-container>
